import {QD_HELP_URL_QUESTION} from "../constants/systemConstants";

// Note: These are referenced by parsing the URL
// Except, unpublishedQuestionnaires

const helpMap = {
        pageNames: {
                qd2admin: "Questionnaires",
                questionnaires: "Questionnaires_Template_Grid_Window",
                categories: "Category_Template_Grid_Windows",
                groups: "Groups_Template_Grid_Windows", // DOES NOT WORK need CSHID
                questions: "Questions_Template_Grid_Windows",
                actions: "Actions_Grid_Window",
                "search-tags": "Tags_Grid_Window",
                integrations: "Integrations",
                import: "Import_Questionnaire",
                unpublishedQuestionnaires: "Viewing_the_Questionnaire_Alert_Banner"
        },
        folderNames: {
                qd2admin: "Quick Help - Questionnaires/QD Quick Help",
                questionnaires: "Quick Help - Questionnaires/QD Quick Help",
                categories: "Quick Help - Categories/QD Quick Help - Categories",
                groups: "Quick Help - Groups/QD Quick Help",
                questions: "Quick Help - Questions/QD Quick Help",
                actions: "Quick Help - Actions/QD Quick Help",
                "search-tags": "Quick Help - Tags/QD Quick Help",
                integrations: "Quick Help - Integrations/QD Quick Help",
                import: "Quick Help - Import Questionnaires/QD Quick Help",
                unpublishedQuestionnaires: "Quick Help - Viewing the Questionnaire Alert Banner/QD Quick Help"
        },
        buildPath: function (name) {return QD_HELP_URL_QUESTION + helpMap.folderNames[name] + ".htm#cshid=" + helpMap.pageNames[name];}
};

export default helpMap;